var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "realTaskMenu" }, [
    _c("div", { staticClass: "menuHerder" }),
    _vm._v(" "),
    _c("div", { staticClass: "menuBodyDad" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "menuFoot" }, [
        _c(
          "div",
          {
            staticClass: "tabStyle",
            class: _vm.cut_result == 1 ? "selectStyle" : "",
            on: {
              click: function($event) {
                return _vm.cut(1)
              }
            }
          },
          [_vm._m(1)]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tabStyle",
            class: _vm.cut_result == 2 ? "selectStyle" : "",
            on: {
              click: function($event) {
                return _vm.cut(2)
              }
            }
          },
          [_vm._m(2)]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menuBody" }, [
      _c("p", { staticStyle: { color: "#999999" } }, [_vm._v("智能审计")]),
      _vm._v(" "),
      _c("p", [_vm._v("真实任务")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "selectStyle1" }, [
      _c("p", [_vm._v("班级企业管理")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "selectStyle1" }, [
      _c("p", [_vm._v("项目总包管理")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25fe2cce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25fe2cce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auditNewRealTask/components/realTaskMenu.vue
// module id = null
// module chunks = 